import React from 'react';
import ReactTooltip from 'react-tooltip';
import ModernDatepicker from 'react-modern-datepicker';

const DateComponent = ({
  title, onChange, value, maxDate, minDate, dateFormat, tooltip,
}) => (
  <div className="form-group">
    {tooltip ? (
      <React.Fragment>
        <ReactTooltip
          id={title}
          place="right"
          type="dark"
          effect="solid"
          getContent={dataTip => (<p className="tooltip-select-small">{dataTip}</p>)}
        />
        <p className="margin-bottom-2">
          {title}
          &nbsp;
          <i className="fas fa-question-circle" value="open" data-tip={tooltip} data-for={title} />
        </p>
      </React.Fragment>
    ) : <p className="margin-bottom-2">{title}</p>}
    <ModernDatepicker
      date={value}
      format={dateFormat}
      showBorder
      maxDate={maxDate}
      onChange={onChange}
      className="form-control custom-select"
    />
  </div>
);

export default DateComponent;
